import { createRouter, createWebHashHistory } from 'vue-router';
import Dashboard from './components/Dashboard.vue';

const routes = [
    {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
    },
    {
        path: '/cliente',
        name: 'cliente',
        component: () => import('./pages/Clientes.vue')
    },
    {
        path: '/proveedor',
        name: 'proveedor',
        component: () => import('./pages/Proveedores.vue')
    },
    {
        path: '/insumos',
        name: 'Insumos',
        component: () => import('./pages/Insumos.vue')
    },
    {
        path: '/ManoDeObra',
        name: 'ManoDeObra',
        component: () => import('./pages/ManoDeObra.vue')
    },
    {
        path: '/productos',
        name: 'productos',
        component: () => import('./pages/Productos.vue')
    },
    {
        path: '/productos/crear',
        name: 'productoscreate',
        component: () => import('./pages/productos/create.vue')
    },
    {
        path: '/productos/editar/:id',
        name: 'productosedit',
        component: () => import('./pages/productos/edit.vue')
    },
    {
        path: '/maquinaria',
        name: 'maquinaria',
        component: () => import('./pages/Maquinaria.vue')
    },
    {
        path: '/logistica',
        name: 'logistica',
        component: () => import('./pages/Logistica.vue')
    },
    {
        path: '/material',
        name: 'material',
        component: () => import('./pages/Materiales.vue')
    },
    {
        path: '/usuario',
        name: 'usuario',
        component: () => import('./pages/Users.vue')
    },
    {
        path: '/produccion',
        name: 'produccion',
        component: () => import('./pages/production/list.vue')
    },
    {
        path: '/produccion/:id',
        name: 'ordenprod',
        component: () => import('./pages/production/show.vue')
    },
    {
        path: '/orden/:id',
        name: 'oti',
        component: () => import('./pages/production/oti_show.vue')
    },
    {
        path: '/produccion/:id/addorder',
        name: 'CreateOti',
        component: () => import('./pages/production/oti_create.vue')
    },
    {
        path: '/produccion/crear',
        name: 'CreateProduccion',
        component: () => import('./pages/production/create.vue')
    },
    {
        path: '/produccion/editar/:id',
        name: 'EditProduccion',
        component: () => import('./pages/production/edit.vue')
    },
    {
        path: '/estadisticas/:of',
        name: 'Stats',
        component: () => import('./pages/Stats.vue')
    },
    {
        path: '/mantenimiento',
        name: 'Mantenimiento',
        component: () => import('./pages/Mantenimiento.vue')
    },
    {
        path: '/configuraciones',
        name: 'Configuraciones',
        component: () => import('./pages/Configuraciones.vue')
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;
